import { styled } from 'styled-components';
import { Typography } from '@altibox/design-system-component-lib';

import { spacing1 } from 'app/style/spacing';

export const StyledTitle = styled(Typography)`
    font-weight: bold;
    padding-bottom: ${spacing1};
`;
